import { ButtonWithIcon } from "@src/components/atoms/buttons/button-with-icon/button-with-icon";
import { Title } from "@src/components/atoms/title/title";
import React from "react";
import styles from "./ota-firmware-start.module.scss";
import FirmwareIcon from "@src/assets/svg/firmware-icon-black.svg";
import { useDispatch } from "react-redux";
import { updateModalsCloseDrawerModal } from "@src/reducers/your-reducer";
import { useI18N } from "@src/language/language-context";
import { RenderIfUserHasPermission } from "@src/components/molecules/render-if-user-has-permission/render-if-user-has-permission";

const cssClassName = "ota-firmware-start";
const OtaFirmwareStart = () => {
  const dispatch = useDispatch();
  const i18n = useI18N();
  const texts = {
    noFirmwareAvailableText: i18n(
      "modules.otaFirmwareStart.noFirmwareAvailableText",
    ),
    uploadYourFirmwareText: i18n(
      "modules.otaFirmwareStart.uploadYourFirmwareText",
    ),
    uploadFirmwareText: i18n("modules.otaFirmwareStart.uploadFirmwareText"),
  };
  const showOTAFirmwareVersionDrawer = () => {
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: true,
        id: "otaFirmwareVersionDrawerModal",
      }),
    );
  };
  return (
    <div className={styles[cssClassName]}>
      <p className={styles[`${cssClassName}__no-firmware`]}>
        {texts.noFirmwareAvailableText}
      </p>
      <RenderIfUserHasPermission permission="manage-firmware">
        <Title text={texts.uploadYourFirmwareText} tag={"h2"} />
        <div className={styles[`${cssClassName}__cta`]}>
          <ButtonWithIcon
            fun={() => showOTAFirmwareVersionDrawer()}
            text={texts.uploadFirmwareText}
            icon={FirmwareIcon}
          />
        </div>
      </RenderIfUserHasPermission>
    </div>
  );
};

export default OtaFirmwareStart;
